import classNames from 'classnames';
import styled from 'styled-components';
import PersonWidgetSalesAlignment from '../../common/components/PersonWidgetSalesAlignment';
import SalesAlignmentComponent from './SalesAlignmentComponent';
import { primaryColor, primaryFont, wMedium, wMBold, secondaryFont, maxWidth1300, maxMobile, scrollbarX, smMobile, maxTablet, minWidthApp, primaryHeadingColor } from '../../../Utils/utilsStyle';
import {
  AlignmentList,
  Executive,
  InsightsCompatibility,
  PersonalityInsights,
  PersonCard,
} from 'Types/PersonTypes';
import {
  personCard,
  selectInsightsData,
  selectSalesAlignmentPersons,
  selectSearchedPersonData,
} from 'Selector/PersonProfileSelector';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import SalesAlignmentPopover from './SalesAlignmentPopover';
import { Popover, Spin } from 'antd';
import { actions as companiesAction } from '../../../Slice/CompaniesSlice';
import { actions as personProfileAction } from '../../../Slice/PersonProfileSlice';
import { selectNotableStaff, selectNotableStaffCount, selectNotableStaffLoading } from '../../../Selector/CompaniesSelector';
import { IsMobile } from '../../../Utils/UtilityFunctions';
import PeopleLookupSection
  from './PeopleLookupSection';
import { selectAffinitySelectedPersonId } from '../../../Selector/AffinitySearchSelector';
import RemoveAlignmentModal from '../../common/components/RemoveAlignmentModal';
import AddAlignmentRowPopover from './AddAlignmentRowPopover';
import { SalesAlignmentItem } from '../../../Types/GlobalTypes';
import PersonSkeleton from '../../common/skeleton/PersonSkeleton';
import SecondaryColorLogo from '../../common/assets/svgIcons/SearchIcon';
const StyledWrapper = styled.div`
  margin: 24px auto;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.09);
  width: 100%;
  padding-right: 35px;
  position: relative;
  /* &:last-child {
    margin: 24px auto 48px auto;
  } */
  @media all and (max-width: ${maxMobile}) {
    // padding-bottom: 32px;
    padding-right: 0px;
  }
  .user-section {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 20px;
    min-width: 280px;
    flex-shrink: 0;
    border-right: 0px solid #BFBFBF;
    @media all and (max-width: ${maxMobile}) {
      min-width: 248px; 
    }
    .search-div {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 8px;
      .icon {
        cursor: pointer;
      }
      .text {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 14px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.349px;
      }
    }
    .add-alignment-btn {
      position: absolute;
      bottom: -34px;
      background: #1EC252;
      width: 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px;
      border-radius: 0px 0px 16px 16px;
      @media all and (max-width: ${maxWidth1300}) {
        bottom: 0px;
        z-index: 1;
      }
      .button-text {
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 18.095px;
        letter-spacing: -0.377px;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 8px;
        cursor: pointer;
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }
    .add-alignment-row {
      position: absolute;
      bottom: 0px;
      z-index: 1;
      left: calc(50% + 27px);

    }
    .remove-alignment-btn {
      position: absolute;
      top: 0px;
      left: 0px;
      writing-mode: sideways-rl;
      background: #DEF6E6;
      padding: 8px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1EC252;
      text-align: center;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 18.095px;
      letter-spacing: -0.377px;
      border-radius: 16px 0 0 16px !important;
      cursor: pointer;
    }
  }
  .table-width-decide {
    @media all and (max-width: ${maxWidth1300}) {
      overflow-x: scroll;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      ${scrollbarX}
    }
    .first-row {
      display: flex;
      min-height: 300px;
      @media all and (max-width: ${maxMobile}) {
        min-height: auto;
      }
      .person-section {
        display: flex;
        justify-content: center;
        flex: 1;
        @media all and (max-width: ${maxMobile}) {
          border-top: 1px solid #BFBFBF;
        }
        .item {
          border-left: 1px solid #BFBFBF;
          display: flex;
          flex-direction: column;
          row-gap: 4px;
          align-items: center;
          justify-content: center;
          @media all and (max-width: ${maxTablet}) {
            min-width: 280px;
            padding: 20px 12px;
            flex-shrink: 0;
          }
          @media all and (max-width: ${maxMobile}) {
              min-width: 248px;
              &:last-child{
                margin-right: 37px;
            }
          }
        }
      }
    }
    
    .second-row {
      display: flex;
      min-height: 300px;
      @media all and (max-width: ${maxMobile}) {
        min-height: auto;
      }
      .alignment-section {
        display: flex;
        justify-content: center;
        flex: 1;
        .item {
          border-left: none;
          &:first-child {
            border-left: 1px solid #BFBFBF;
          }
          &:not(:last-child) {
            border-right: 1px solid #BFBFBF;
          }
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
        }
      }
    }
  }
  &.persons-length-4 {
    .first-row {
      @media all and (max-width: ${maxWidth1300}) {
        width: calc(100vw + 50px);
      }
      @media all and (max-width: ${maxTablet}) {
        width: calc(100vw + 200px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100vw + 300px);
      };
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 400px);
      };
      .person-section {
        .item {
          flex: 1 1 25%;
        }
      }
    }
    .second-row {
      @media all and (max-width: ${maxWidth1300}) {
        width: calc(100vw + 50px);
      }
      @media all and (max-width: ${maxTablet}) {
        width: calc(100vw + 200px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100vw + 300px);
      };
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 400px);
      };
      .alignment-section {
        .item {
          flex: 1 1 25%;
        }
      }
    }
  }
  &.persons-length-3 {
    .first-row {
      @media all and (max-width: ${minWidthApp}) {
        width: calc(100vw + 50px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100vw + 200px);
      }
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 300px);
      }
      .person-section {
        .item {
          flex: 1 1 30%;
        }
      }
    }
    .second-row {
       @media all and (max-width: ${minWidthApp}) {
        width: calc(100vw + 50px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100vw + 200px);
      }
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 300px);
      }
      .alignment-section {
        .item {
          flex: 1 1 30%;
        }
      }
    }
  }
  &.persons-length-2 {
    .first-row {
      @media all and (max-width: 850px) {
        width: 100vw;
      }
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 200px);
      }
      .person-section {
        .item {
          flex: 1 1 50%;
        }
      }
    }
    .second-row {
      @media all and (max-width: 850px) {
        width: 100vw;
      }
      @media all and (max-width: ${smMobile}) {
        width: calc(100vw + 200px);
      }
      .alignment-section {
        .item {
          flex: 1 1 50%;
        }
      }
    }
  }
  &.persons-length-1 {
    .first-row {
      .person-section {
        .item {
          flex: 1 1 100%;
        }
      }
    }
    .second-row {
      .alignment-section {
        .item {
          flex: 1 1 100%;
        }
      }
    }
  }
  .add-people-btn {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    writing-mode: vertical-rl;
    background: ${primaryColor};
    color: #fff;
    padding: 16px 6px;
    border-radius: 0px 16px 16px 0px;
    height: 100%;
    .button-text {
      text-align: center;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 18.095px;
      letter-spacing: -0.377px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 8px;
      cursor: pointer;
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
    
    .count {
      margin-top: 8px;
      writing-mode: horizontal-tb;
      border-radius: 4px;
      background: #DEF6E6;
      padding: 4px;
      color: ${primaryColor};
      text-align: center;
      font-family: ${secondaryFont};
      font-size: 12px;
      font-weight: ${wMBold};
      line-height: 16px;
      letter-spacing: -0.367px;
    }
  }
  .add-people-popover {
    position: absolute;
    right: 40px;
    top: 50%;
    z-index: 1;
    .ant-popover-open {
      .ant-popover {
        .ant-popover-content {
          .ant-popover-inner {
            padding: 16px 4px 13px 16px;
          }
        }
      }
    }
  }
  @media all and (max-width: ${maxTablet}) {
    .multisales-centered-popover.ant-popover {
      position: fixed !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: auto !important;
      max-width: calc(100vw - 32px) !important;
    }
    .multisales-centered-popover.ant-popover .ant-popover-inner {
      width: 254px;
      max-width: calc(100vw - 32px);
    }
  }
`;
const TableWrapper = styled.div`
  
`;

type Props = {
  insights: PersonalityInsights[],
  commonalitiesData: string[],
  commonalitiesTitle: string,
  companyName?: string,
};

const MultiSalesAlignment = function MultiSalesAlignment(props: Props) {
  const {
    insights,
    commonalitiesData = [],
    commonalitiesTitle = '',
  } = props;
  const dispatch = useDispatch();
  const salesAlignmentPersons = useSelector(selectSalesAlignmentPersons);
  const loading: boolean = salesAlignmentPersons.loading;
  const isMob = IsMobile();
  const [activePopover, setActivePopover] = useState<number | null>(null);
  const [openLockedAffinityPopoverByRowId, setOpenLockedAffinityPopoverByRowId] = useState<Record<number, boolean>>({});
  const [openSearchAffinityPopoverByRowId, setOpenSearchAffinityPopoverByRowId] = useState<Record<number, boolean>>({});
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [rowToRemove, setRowToRemove] = useState<number | null>(null);
  const normalizedCommonalitiesData = Array.isArray(commonalitiesData) ? commonalitiesData : [];
  const searchedPersonData: PersonalityInsights[] = useSelector(selectSearchedPersonData);
  const searchedPersonSelected: boolean = searchedPersonData.length > 0;
  const popoverInnerStyle = {
    width: 254,
    maxWidth: 254,
  };
  const popoverOverlayStyle = {
    width: 'auto',
    maxWidth: 'calc(100vw - 32px)',
  };
  const prevRowsCountRef = useRef<number>(0);
  const didInitRowsRef = useRef(false);
  const seededRow0Ref = useRef<string | null>(null);

  const approach = useMemo(() => {
    if (insights && insights.length > 0) {
      const data = insights.find((item) => item.type === 'approach');
      if (data) {
        return data;
      }
    }
    return {
      type: '',
      title: '',
      dataList: [],
      data: [],
    };
  }, [insights]);

  useEffect(() => {
    const rows = salesAlignmentPersons.rows;
    const prevCount = prevRowsCountRef.current

    const latestIncompleteRow = [...rows]
      .reverse()
      .find((r) => r.rowId > 0 && !r.currentUser?.personId);

    if (!didInitRowsRef.current) {
      didInitRowsRef.current = true;
      prevRowsCountRef.current = rows.length;

      setOpenSearchAffinityPopoverByRowId({});

      if (latestIncompleteRow) {
        setOpenLockedAffinityPopoverByRowId((prev) => ({
          ...prev,
          [latestIncompleteRow.rowId]: true,
        }));
      }
      return;
    }

    if (rows.length > prevCount) {
      const lastRow = rows[rows.length - 1];
      if (lastRow.rowId > 0 && !lastRow.currentUser?.personId) {
        setOpenLockedAffinityPopoverByRowId((prev) => ({
          ...prev,
          [lastRow.rowId]: true,
        }));
      }
    }
    prevRowsCountRef.current = rows.length;
  }, [salesAlignmentPersons.rows])

  const closeLockedAffinityPopover = (rowId: number) => {
    setOpenLockedAffinityPopoverByRowId((prev) => {
      const next = { ...prev };
      delete next[rowId];
      return next;
    });
  };

  const closeSearchAffinityPopover = (rowId: number) => {
    setOpenSearchAffinityPopoverByRowId((prev) => {
      const next = { ...prev };
      delete next[rowId];
      return next;
    });
  };

  const addAlignmentHandler = () => {
    dispatch(personProfileAction.addNewAlignmentRow());
  }

  useLayoutEffect(() => {
    const row0 = salesAlignmentPersons?.rows?.[0];
    const row0Id = row0?.rowId;
    const basePersonId = row0?.currentUser?.personId;
    const firstComparedPersonId = row0?.personsList?.[0]?.person?.personId;

    if (
      row0Id === undefined
      || row0Id < 0
      || !basePersonId
      || !firstComparedPersonId
      || !Array.isArray(normalizedCommonalitiesData)
    ) {
      return;
    }

    const key = `${basePersonId}:${firstComparedPersonId}`;

    if (seededRow0Ref.current === key) {
      return;
    }

    seededRow0Ref.current = key;

    dispatch(personProfileAction.seedSalesAlignmentInsight({
      rowId: row0Id,
      basePersonId,
      personId: firstComparedPersonId,
      approachTips: approach.dataList,
      commonalities: {
        title: commonalitiesTitle,
        dataList: normalizedCommonalitiesData,
      },
    }));
  }, [
    dispatch,
    salesAlignmentPersons?.rows,
    normalizedCommonalitiesData,
    commonalitiesTitle,
    approach.dataList,
  ]);

  return (
    <>
      <Spin spinning={loading}>
        {
          salesAlignmentPersons?.rows.map((row, index) => (

            <StyledWrapper
              key={row.rowId}
              className={classNames(`persons-length-${row.personsList?.length} multi-sales-container`)}
            >
              <div
                className={classNames('add-people-btn')}
                role='button'
                tabIndex={0}
              >
                <span
                  className={classNames('button-text', { disabled: row.personsList.length === 4 || !!openLockedAffinityPopoverByRowId[row.rowId] })}
                  onClick={() => setActivePopover(index === activePopover ? null : index)}
                >
                  <span>+</span>
                  Add People
                  <span className='count'>{`${row.personsList.length}/4`}</span>
                </span>
              </div>
              <div className='add-people-popover'>
                <Popover
                  open={activePopover === index}
                  onOpenChange={(value) => setActivePopover(value ? index : null)}
                  trigger="click"
                  placement="left"
                  overlayClassName="multisales-centered-popover"
                  overlayStyle={popoverOverlayStyle}
                  overlayInnerStyle={popoverInnerStyle}
                  arrow={false}
                  autoAdjustOverflow={false}
                  getPopupContainer={(e: HTMLElement) => e}
                  zIndex={1}
                  content={
                    <SalesAlignmentPopover
                      personsList={row.personsList}
                      basePersonId={row.currentUser?.personId}
                      currentCompanyId={row.personsList?.[0]?.person.companyId}
                      closePopover={() => setActivePopover(null)}
                      rowId={row.rowId}
                      searchedPersonSelected={searchedPersonSelected}
                    />
                  }
                >
                  <span />
                </Popover>
              </div>
              <TableWrapper>
                <div className='table-width-decide'>
                  <div className='first-row'>
                    <div
                      className={classNames('user-section', {
                        'has-add-alignment': index === (salesAlignmentPersons.rows.length - 1),
                      })}
                    >
                      {
                        row.currentUser ? (
                          <>
                            <PersonWidgetSalesAlignment
                              rowId={row.rowId}
                              personName={row.currentUser?.personName}
                              personImage={row.currentUser?.personImage}
                              personDesignation={row.currentUser?.personDesignation}
                              persona={row.currentUser?.personalityTypes?.[0]?.color}
                              typeName={row.currentUser?.archeType?.name}
                              personId={row.currentUser?.personId}
                              companyName={row.currentUser?.companyName}
                            />
                            {
                              index !== 0 && (
                                <div
                                  className='search-div'
                                  role='button'
                                  tabIndex={0}
                                  onClick={() => {
                                    // For already-selected affinity person rows, Search should open a dismissible
                                    if (!row.currentUser?.personId) return;
                                    setOpenSearchAffinityPopoverByRowId((prev) => ({
                                      ...prev,
                                      [row.rowId]: true,
                                    }));
                                  }}
                                >
                                  <span className='icon'>
                                    <SecondaryColorLogo />
                                  </span>
                                  <span className='text'>Search</span>
                                </div>
                              )
                            }

                          </>
                        ) : (
                          <PersonSkeleton hideBtn hideTitle />
                        )
                      }

                      {
                        // Affinity-person popover anchor for each row (except the primary row).
                        index !== 0 && (
                          <div className='add-alignment-row'>
                            <Popover
                              open={
                                !!openLockedAffinityPopoverByRowId[row.rowId]
                                || !!openSearchAffinityPopoverByRowId[row.rowId]
                              }
                              onOpenChange={(open) => {
                                if (open) {
                                  // We generally open this popover programmatically (new-row auto open / Search click).
                                  return;
                                }

                                // If the locked popover is open (new row without affinity selected), ignore outside click.
                                if (!!openLockedAffinityPopoverByRowId[row.rowId] && !row.currentUser?.personId) {
                                  return;
                                }

                                closeLockedAffinityPopover(row.rowId);
                                closeSearchAffinityPopover(row.rowId);
                              }}
                              trigger="click"
                              placement='top'
                              overlayClassName="multisales-centered-popover"
                              overlayStyle={popoverOverlayStyle}
                              overlayInnerStyle={popoverInnerStyle}
                              arrow={false}
                              autoAdjustOverflow={false}
                              zIndex={1}
                              getPopupContainer={(e: HTMLElement) => e}
                              content={
                                <AddAlignmentRowPopover
                                  currentUser={salesAlignmentPersons.rows?.[index]?.currentUser === null ? salesAlignmentPersons.rows?.[0]?.currentUser : salesAlignmentPersons.rows?.[index]?.currentUser}
                                  userIds={salesAlignmentPersons.rows}
                                  rowId={row.rowId}
                                  personsList={row.personsList?.[0]?.person}
                                  closePopover={() => {
                                    closeLockedAffinityPopover(row.rowId);
                                    closeSearchAffinityPopover(row.rowId);
                                  }}
                                />
                              }
                            >
                              <span />
                            </Popover>
                          </div>
                        )
                      }

                      {
                        index === (salesAlignmentPersons.rows.length - 1) && (
                          <>
                            <div
                              className={classNames('add-alignment-btn')}
                              role='button'
                              tabIndex={0}
                            >
                              <span
                                className={classNames('button-text', { disabled: salesAlignmentPersons.rows.length === 4 || !!openLockedAffinityPopoverByRowId[row.rowId] })}
                                onClick={() => {
                                  addAlignmentHandler()
                                }}
                              >
                                <span>+</span>
                                Add Alignment
                              </span>
                            </div>
                          </>
                        )
                      }
                      {
                        index !== 0 && (
                          <div
                            className={classNames('remove-alignment-btn')}
                            role='button'
                            tabIndex={0}
                            onClick={() => {
                              setRowToRemove(row.rowId)
                              setShowRemovePopup(true);
                            }}
                          >
                            Remove Alignment
                          </div>
                        )
                      }
                    </div>
                    {
                      row.personsList?.length && (
                        <div className='person-section'>
                          {
                            row.personsList.map((item: SalesAlignmentItem, idx: number) => (
                              idx === 0 ? (
                                <div className='item' key={item?.person?.personId || idx}>
                                  <PersonWidgetSalesAlignment
                                    rowId={row.rowId}
                                    personName={item?.person.personName}
                                    personImage={item?.person.personImage}
                                    personDesignation={item?.person.personDesignation}
                                    persona={item?.person.personalityTypes?.[0]?.color}
                                    typeName={item?.person.archeType?.name}
                                    personId={item?.person.personId}
                                    companyName={item?.person.companyName}
                                  />
                                  <SalesAlignmentComponent
                                    rowId={row.rowId}
                                    match={item?.alignment?.match}
                                    comparedPersonId={item?.alignment?.personId}
                                    personType={item?.alignment?.personType}
                                    disableBtn={!!openLockedAffinityPopoverByRowId[row.rowId]}
                                    approachTips={approach.dataList}
                                    basePersonId={row.currentUser?.personId}
                                    personName={item?.person.personName}
                                    personaColor={item?.person.personalityTypes?.[0]?.color}
                                  />
                                </div>
                              ) : (
                                <div className='item' key={item?.person?.personId || idx}>
                                  <PersonWidgetSalesAlignment
                                    closeIconVisible
                                    rowId={row.rowId}
                                    personName={item?.person.personName}
                                    personImage={item?.person.personImage}
                                    personDesignation={item?.person.personDesignation}
                                    persona={item?.person.personalityTypes?.[0]?.color}
                                    typeName={item?.person.archeType?.name}
                                    personId={item?.person.personId}
                                    companyName={item?.person.companyName}
                                  />
                                  <SalesAlignmentComponent
                                    rowId={row.rowId}
                                    match={item?.alignment?.match}
                                    comparedPersonId={item?.alignment?.personId}
                                    personType={item?.alignment?.personType}
                                    disableBtn={!!openLockedAffinityPopoverByRowId[row.rowId]}
                                    approachTips={item?.alignment?.approachTips}
                                    basePersonId={row.currentUser?.personId}
                                    personName={item?.person.personName}
                                    personaColor={item?.person.personalityTypes?.[0]?.color}
                                  />
                                </div>
                              )
                            ))
                          }
                        </div>
                      )
                    }
                  </div>
                </div>
              </TableWrapper>
            </StyledWrapper>
          ))
        }
      </Spin>
      <RemoveAlignmentModal
        isVisible={showRemovePopup}
        setIsVisible={setShowRemovePopup}
        rowId={rowToRemove ?? -1}
      />
    </>
  )
};
export default MultiSalesAlignment;